<template>
  <v-card class="ma-4" :loading="state.loading">
    <toolbar-view title="Алерты ошибок на клиенте"/>
    <v-simple-table dense class="table3" fixedHeader :height="pageHeight-48-32-48">
      <template v-slot:default>
        <thead>
          <tr>
            <th>Создано</th>
            <th>Пользователь</th>
            <th>Ошибка</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, k) in state.data" :key="k">
            <td>{{v[1]}}</td>
            <td>{{v[0][1]}}</td>
            <td>{{v[3].join(',')}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import Stater from "@/plugins/stater";
import axios from "axios";
import ToolbarView from "../../components/ToolbarView.vue";
import pageHeight from "../../mixins/pageHeight";

export default {
  components: {ToolbarView},
  mixins:[pageHeight],
  data: () => ({
    state: new Stater(),
  }),
  mounted() {
    this.load();
  },
  methods:{
    load(){
      this.state.stateLoading()
      axios.get('/napi/log/clientAlertError/')
          .then(r => {
            this.state.data = r.data
            this.state.stateSuccess()
          })
          .catch(() => {
            this.state.stateError()
          })
      ;
    },
  }
}
</script>